"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { HiChevronRight, HiChevronLeft, HiMenu, HiDotsVertical, HiX, HiArrowNarrowLeft } from "react-icons/hi";
import { FaFile, FaBars  } from "react-icons/fa";
import { CategoryGlyph } from "@/components/CategoryGlyph";

export default function Sidebar({ sidebarOpen, setSidebarOpen, categories }) {
  const safeCats = Array.isArray(categories) ? categories : [];
  const parentMap = safeCats.reduce((acc, cat) => {
    const pid = cat.parent_id != null ? cat.parent_id : null;
    if (!acc[pid]) acc[pid] = [];
    acc[pid].push(cat);
    return acc;
  }, {});
  Object.keys(parentMap).forEach((k) => {
    parentMap[k].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  });

  const [selectedParent, setSelectedParent] = useState(null);
  const [openChild, setOpenChild] = useState(null);

  useEffect(() => {
    if (!selectedParent && parentMap[null]?.length > 0) {
      setSelectedParent(parentMap[null][0].id);
    }
  }, [parentMap, selectedParent]);

  const handleParentClick = (id) => {
    setSelectedParent(id);
    setOpenChild(null);
  };

  const handleChildClick = (id) => {
    setOpenChild(openChild === id ? null : id);
  };

  const children = selectedParent ? parentMap[selectedParent] || [] : [];

  return (
    <div
      className={`fixed top-0 left-0 h-full w-200 p-5 bg-white shadow-lg z-50 transform transition-transform duration-300 ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      {/* <div className="flex justify-end p-4">
        <button
          onClick={() => setSidebarOpen(false)}
          className="text-gray-700 font-bold text-xl hover:text-gray-900 transition-colors"
        >
          ×
        </button>
      </div> */}

      <div className="flex h-[calc(100%-64px)] overflow-y-auto">
        {/* Left column: Parents */}
        <div className="w-2/2 overflow-y-auto">
          {(parentMap[null] || []).map((parent) => (
           <button
              key={parent.id}
              onClick={() => handleParentClick(parent.id)}
              className={`w-full flex items-center gap-2 px-2 py-2 text-sm text-left cursor-pointer rounded
                ${
                  selectedParent === parent.id
                    ? "bg-gradient-to-r from-[#0053E2] to-purple-600 text-white font-medium"
                    : "text-gray-800 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#0053E2] hover:to-purple-600"
                }`}
            >
              {String(parent.icon || "").trim() ? (
                <CategoryGlyph icon={parent.icon} size="md" />
              ) : (
                <HiDotsVertical className={`flex-shrink-0 text-base text-gray-800 ${
                    selectedParent === parent.id
                      ? "text-white"
                      : "text-black"
                  }`} />
              )}
              <span title={parent.name} className="flex-1 truncate">{parent.name}</span>
              <HiChevronRight className={`flex-shrink-0 text-base text-gray-800 ${
                  selectedParent === parent.id
                    ? "text-white"
                    : "text-black"
                }`} />
            </button>

          ))}
        </div>

        <div className="w-2/2 overflow-y-auto pl-5">
            <div className="flex justify-between items-center p-1 bg-gray-50 sticky top-0 z-10 gap-2">
              <button
                onClick={() => setSidebarOpen(false)}
                className="cursor-pointer flex items-center justify-center w-8 h-8 text-gray-700 rounded
                            transition-transform duration-200 ease-in-out
                            hover:scale-110 hover:text-gray-900"
              >
                <HiArrowNarrowLeft size={24} />
              </button>
              <Link href={`/partner/partnercategory?search=${selectedParent}`} onClick={() => setSidebarOpen(false)}>
                <button
                  className="cursor-pointer px-3 py-1 text-sm font-medium text-gray-700 hover:text-white hover:bg-gradient-to-r hover:from-[#0053E2] hover:to-purple-600 rounded transition-all text-center"
                >
                  Бүгдийг үзэх
                </button>
              </Link>
            </div>
            {children.length === 0 ? (
              <div className="p-4 text-gray-500 select-none">
                Select a parent category
              </div>
            ) : (
              children.map((child) => {
                const subChildren = parentMap[child.id] || [];

                return (
                  <div key={child.id} className="mb-1">
                    {/* Child */}
                    <Link href={`/partner/partnercategory?search=${child.id}`} onClick={() => setSidebarOpen(false)}>
                      <button
                        className="w-full flex items-center gap-2 px-2 py-2 text-sm text-left cursor-pointer rounded"
                      >
                        <span title={child.name} className="cursor-pointer flex-1 truncate text-gray-800 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#0053E2] hover:to-purple-600">{child.name}</span>
                      </button>
                    </Link>
                    {/* Sub-children */}
                    {subChildren.length > 0 &&
                      subChildren.map((sub) => (
                        <Link
                          key={sub.id}
                          href={`/partner/partnercategory?search=${sub.id}`}
                          className="block ml-6 mt-1 px-2 py-1 text-sm text-gray-700 hover:bg-gray-50 rounded truncate transition-colors"
                          onClick={() => setSidebarOpen(false)}
                        >
                          {sub.name}
                        </Link>
                      ))}
                  </div>
                );
              })
            )}
          </div>
      </div>
    </div>
  );
}
